import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  cardContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    padding: 0,
    justifyContent: 'center'
  },
  progress: {
    margin: UNIT * 5,
    textAlign: 'center',
    color: mainColor.secondaryColor
  },
  icon: {
    fontSize: UNIT,
    backgroundColor: 'transparent',
    color: mainColor.colorWhite
  },

  arroundIcon: {
    backgroundColor: mainColor.colorDarkGray,
    display: 'flex',
    padding: 2,
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    right: -UNIT * 0.5,
    zIndex: 1,
    top: -UNIT * 0.5
  },
  textTitle: {
    fontWeight: 'bold',
    width: '100%',
    overflow: 'hidden',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },

  descriptionStyle: {
    fontSize: UNIT * 0.625,
    marginTop: 0,
    width: '100%',
    fontStyle: 'italic',
    overflow: 'hidden',
    textAlign: 'center',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    right: 0,
    bottom: 0
  },
  paper: {
    padding: UNIT * 0.625,
    paddingTop: 0,
    borderRadius: UNIT,
    margin: UNIT * 0.625,
    position: 'relative',
    width: UNIT * 11.71875,
    maxHeight: UNIT * 25
  },

  card: {
    height: UNIT * 9.375,
    width: UNIT * 11.71875,
    display: 'flex',
    justifyContent: 'center'
  },
  priceFormat: { marginBottom: '0.5rem', fontWeight: 'bold' },
  noImageIcon: {
    width: '50%',
    height: '50%',
    color: mainColor.colorDarkGray,
    alignSelf: 'center'
  },
  hrStyle: {
    border: '0',
    height: '2px',
    backgroundColor: mainColor.secondaryColor,
    width: UNIT * 1.875,
    backgroundImage:
      'linear-gradient(to right, rgba(200, 200, 200, 0.5), rgba(200, 200, 200, 0.75), rgba(200, 200, 200, 0.5))'
  },
  mediaStyle: { fontSize: UNIT * 0.5, color: mainColor.colorDarkGray, fontWeight: 'bold' }
});
